import ExtractorSessionLifeCycleFilter from "components/filters/Filters/ExtractorSessionLifeCycleFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import React from "react";

const Filters = () => {
  return <>
    <OwnersFilter />
    <ExtractorSessionLifeCycleFilter />
  </>;
};

export default Filters;
